import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import EventEmitterExResident from '../shared/pageBaseComponents/EventEmitterExResident'
import {RESERVATION_TYPE} from '../../CodeMaster'
import {CompleteImageArea, CompleteMessage, StyledSecondaryButton} from './components/CommonStyle'
import {CenterPlainLinkStyledButton} from '../../styledComponents/Button'
import {BlockSpacer} from '../../styledComponents/ResponsiveConvenience'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    facilityId: number
    eventEmitter: EventEmitterExResident
    location: Location<LocationState>
}

interface LocationState {
    transitionInputPage: boolean
    reserveType: string
}

class ResidentReserveFacilityInputCompletePage extends Component<Props & ResidentPagePropsSet> {
    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        this.handleBackMyReservationButtonClick = this.handleBackMyReservationButtonClick.bind(this)
        this.handleBackFacilityReserveTopButtonClick = this.handleBackFacilityReserveTopButtonClick.bind(this)
    }

    handleBackMyReservationButtonClick(): void {
        const {navigate, condominiumCd} = this.props

        navigate(`/resident/condominiums/${condominiumCd}/my-reservations`, {replace: true})
    }

    handleBackFacilityReserveTopButtonClick(): void {
        const {navigate, condominiumCd} = this.props

        navigate(`/resident/condominiums/${condominiumCd}/reserve-facility-top`, {replace: true})
    }

    render(): ReactNode {
        const {transitionInputPage, reserveType} = this.props.location.state

        let completeMessage: string = '予約を確定しました'
        if (transitionInputPage) {
            if (RESERVATION_TYPE.LOTTERY.value === reserveType) {
                completeMessage = '申込みを受け付けました'
            }
        }

        return (<>
            <BlockSpacer height={'60px'}/>
            <CompleteImageArea>
                <img src={'/resources/images/icons/icon_reserve_complete.svg'} width={'120px'} alt={'complete'}/>
            </CompleteImageArea>
            <BlockSpacer height={'20px'}/>
            <CompleteMessage>{completeMessage}</CompleteMessage>
            <BlockSpacer height={'60px'}/>
            <StyledSecondaryButton
                onClick={this.handleBackMyReservationButtonClick}>予約一覧を見る</StyledSecondaryButton>
            <BlockSpacer height={'30px'}/>
            <CenterPlainLinkStyledButton onClick={this.handleBackFacilityReserveTopButtonClick}>
                施設予約へ
            </CenterPlainLinkStyledButton>
            <BlockSpacer height={'30px'}/>
        </>)
    }
}

export default createResidentPage(ResidentReserveFacilityInputCompletePage)
